
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Formik } from 'formik'
import Effect from '../../utils/Effect'
import validate from '../../utils/validateHotels'
import { FormVisualStateContainer } from '../../../common/contexts'

const initialValues = {
  location: '',
  startlocation: '',
  startDate: '',
  endDate: '',
  roomCount: '1',
  isRentalCarNeeded: false,
  isFlightNeeded: false,
  adultCount: 2,
  childrenCount: 0,
  childrenAges: [],
  tripType: 'STAY'
}

const noop = () => {}

export default function HotelsSearchContainer (props) {
  const [calendarOpen, setCalendarOpen] = useState(false)

  const openCalendar = () => {
    setCalendarOpen(true)
  }

  const closeCalendar = () => {
    setCalendarOpen(false)
  }

  const { render, onChange, ...otherProps } = props
  const renderProps = {
    ...props,
    calendarOpen,
    closeCalendar: closeCalendar,
    openCalendar: openCalendar
  }
  return (
    <FormVisualStateContainer.Provider>
      <Formik
        {...otherProps}
        render={formProps => (
          <div>
            <Effect onChange={onChange} />
            {render({ ...renderProps, ...formProps })}
          </div>
        )}
      />
    </FormVisualStateContainer.Provider>
  )
}

HotelsSearchContainer.propTypes = {
  render: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  validate: PropTypes.func
}

HotelsSearchContainer.defaultProps = {
  initialValues,
  validate,
  onChange: noop,
  onSubmit: noop,
  validateOnChange: true,
  validateOnBlur: false
}
